import { useIsMobile } from '@/hooks/use-mobile'
import { appLink } from '@app/config/appLink'
import { useFetchHomeContent } from '@app/hooks/useFetchHomeContent'
import { homeClientContactAtom, homeContactsAtom } from '@app/state/HomeAtoms'
import { getFullName, getImageSource } from '@app/utils/contacts.utils'
import { useAtomValue } from 'jotai'
import { Outlet, useLocation } from 'react-router-dom'
import HomeV2Navbar from '../components/HomeV2Navbar'
import HomeV2NavbarMobile from '../components/HomeV2NavbarMobile'
import ContactPerson, { ContactPersonTypes } from '../components/ContactPerson'
import { getAdvisorRole } from '../config/advisorRoles.config'

const HomeV2Layout = () => {
  const isMobile = useIsMobile()
  const { pathname } = useLocation()
  const shouldHideNavbar = pathname === appLink.homeWelcome.path
  useFetchHomeContent()
  const contacts = useAtomValue(homeContactsAtom)
  const advisor = contacts?.advisor
  const clientContacts = useAtomValue(homeClientContactAtom)

  const contactList = [
    advisor && {
      name: getFullName(advisor),
      role: getAdvisorRole(advisor.email),
      email: advisor.email,
      phone: advisor.phone,
      avatarUrl: getImageSource(advisor),
    },
    ...(clientContacts?.map((c) => ({
      name: getFullName(c),
      role: 'Internal Contact',
      email: c.email,
      phone: c.phone,
      avatarUrl: null,
    })) ?? []),
  ].filter(Boolean) as ContactPersonTypes[]

  return (
    <div className="flex w-full h-screen overflow-hidden">
      <main className="flex-1 overflow-y-auto bg-background">
        {!shouldHideNavbar && (isMobile ? <HomeV2NavbarMobile /> : <HomeV2Navbar />)}
        <Outlet />
      </main>
      {contactList.length > 0 && (
        <div className="sticky bottom-0 z-10">
          <ContactPerson
            contacts={
              contactList as [ContactPersonTypes] | [ContactPersonTypes, ContactPersonTypes]
            }
          />
        </div>
      )}
    </div>
  )
}

export default HomeV2Layout
